// W13 03/11: hide teeinblue "This field is required!" once the customer types in that field.
document.addEventListener('input', function (e) {
  var t = e.target;
  if (!t || !t.name || t.name.indexOf('layer-') !== 0) return;
  var field = t.closest('.tee-field');
  if (!field) return;
  var msg = field.querySelector('.tee-required-message');
  if (msg) msg.style.display = t.value.trim() ? 'none' : '';
}, true);
